import Navbar from './components/Navbar';
import Content from './components/Content';
import './App.css'
function App() {
  return (
    <>
    <Navbar/>
    <Content/>
    </>
  );
}

export default App;
